import {useCallback, useState} from 'react';

import {getUserSessionToken, setUserSessionToken} from '~/shared/utils/userToken';
import apiService from '~/shared/services/apiService';
import {createLogger} from '~/shared/logging';

const logger = createLogger('usePhoneVerification');

const usePhoneVerification = () => {
  const [verificationData, setVerificationData] = useState<Record<string, unknown>>();

  const getVerificationCode = async (email: string) => {
    try {
      const {data}: Record<string, any> = await apiService.getUserAuthenticationDataAndSendAuthenticationCodeToUser({
        email,
      });

      const {codeAuthenticationData} = data;

      setVerificationData({
        authenticationToken: codeAuthenticationData?.authenticationToken,
        isPhoneMethod: codeAuthenticationData?.sendingMethod === 'Phone',
        lastFourPhoneDigits: codeAuthenticationData?.lastFourPhoneDigits,
      });
    } catch (error) {
      const errorType = 'get user authentication code failed';
      logger.error(errorType, {error, fingerprint: errorType});
    }
  };

  const submitVerification = useCallback(async (email: string, authenticationCode?: string): Promise<string | null> => {
    try {
      const params = {
        email,
        authenticationToken: verificationData?.authenticationToken,
        authenticationCode,
      };
      const {data: user} = await apiService.getUserV2(params);
      const currentSessionToken = user?.sessionToken;
      setUserSessionToken(currentSessionToken);
      return currentSessionToken;
    } catch (error: any) {
      const errorType = 'user verification failed';
      logger.error(errorType, {error, fingerprint: errorType});
      throw error;
    }
  }, [verificationData]);

  return {
    getUserCurrentSessionToken: getUserSessionToken,
    getVerificationCode,
    submitVerification,
  };
};

export default usePhoneVerification;
